import { getBearerToken } from "./authService";

export async function request(url, options = {}, timeout) {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => {
    controller.abort();
  }, timeout);

  let token;
  try {
    token = await getBearerToken();
  } catch (error) {
    console.error("Error fetching bearer token:", error);
  }

  if (options.params) {
    const queryString = new URLSearchParams(options.params).toString();
    url += `?${queryString}`;
  }

  const { params, ...restOptions } = options;

  const config = {
    method: restOptions.method || "GET",
    headers: {
      "Content-Type": "application/json",
      ...(restOptions.headers || {}),
      ...(token ? { "Authorization": `Bearer ${token}` } : {}),
    },
    signal: controller.signal,
    ...restOptions,
  };

  let response;
  try {
    response = await fetch(url, config);
    clearTimeout(timeoutId);
  } catch (error) {
    clearTimeout(timeoutId);
    if (error.name === "AbortError") {
      throw new Error("Timeout Expired");
    }
    throw error;
  }

  if (!response.ok) {
    if (response.status === 500) {
      throw new Error("Something went wrong, please try again in a few seconds");
    }
    const errorData = await response.json();
    let errorMessage = "Ooops, something went wrong...";
    if (errorData.detail) {
      if (Array.isArray(errorData.detail)) {
        errorMessage += "\n\n" + response.status + " - " + errorData.detail.map(item => item.msg || JSON.stringify(item)).join("\n");
      } else {
        errorMessage += "\n\n" + response.status + " - " + errorData.detail;
      }
    }
    throw new Error(errorMessage);
  }

  return response.json();
}